import FetchWrapper from '../../../inplant-core-fe/functions/fetchWrapper'

export const API = () => FetchWrapper.getInstance(RECIPE_URL)
export const RECIPE_URL = `recipe-control`
export const CONFIGURATION_URL = `recipe-groups`